import * as React from "react";
import { useTranslations } from "next-intl";
import { useMutation } from "@tanstack/react-query";
import { Button, useToast } from "@chotca/ui";
import { useMe } from "@chotca/api-client";
import { getSdk } from "@chotca/api-client";

export function EmailVerifyBanner() {
  const t = useTranslations("auth");
  const me = useMe();
  const { success, error } = useToast();
  const [dismissed, setDismissed] = React.useState(false);

  const resend = useMutation({
    mutationFn: () => getSdk().auth.requestEmailVerify(),
    onSuccess: () => success(t("verifyEmailResendSent")),
    onError: () => error(t("verifyEmailFailed")),
  });

  if (!me.data) return null;
  if (me.data.emailVerifiedAt) return null;
  if (!me.data.email) return null;
  if (dismissed) return null;

  return (
    <div className="rounded-xl border border-warning/30 bg-sun/30 px-4 py-3 text-body-sm text-ink">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span>
          {t("verifyEmailBanner")}{" "}
          <span className="font-semibold">{me.data.email}</span>
        </span>
        <div className="flex items-center gap-3">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            loading={resend.isPending}
            onClick={() => resend.mutate()}
            className="h-8! px-4! text-xs!"
          >
            {t("verifyEmailResend")}
          </Button>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="flex h-7 w-7 items-center justify-center rounded-full text-lg text-ink/60 hover:bg-ink/10 hover:text-ink"
            aria-label="Đóng"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
